import { render, staticRenderFns } from "./CopyStakeStreamRecordingsView.vue?vue&type=template&id=967fb9da&lang=pug"
import script from "./CopyStakeStreamRecordingsView.vue?vue&type=script&lang=ts"
export * from "./CopyStakeStreamRecordingsView.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeStreamRecordingsView.vue?vue&type=style&index=0&id=967fb9da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VContainer,VRow})
